module.exports = __webpack_public_path__ + "img/information_hot.027a29d4.png";